import React from 'react';
import PropTypes from 'prop-types';
import WizardInput from '../Input';
import Input from '../../Input';
import styles from './styles.less';

const Description = ({ t, title, setValue }) => (
  <>
    <WizardInput title={t('course.create.wizard.step4_1')} hint={t('wizard.hint.title')}>
      <Input
        version="long"
        size="large"
        value={title}
        onChange={e => setValue(e.target.value, 'title')}
        placeholder={t('course.edit.title.placeholder')}
        className={styles.desc_text}
        name="wizard_title"
      />
    </WizardInput>
  </>
);

Description.propTypes = {
  setValue: PropTypes.func,
  t: PropTypes.func,
  title: PropTypes.string,
};

Description.defaultProps = {
  setValue: () => {},
  t: () => {},
  title: '',
};

export default Description;
